import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useScreenSize } from './useScreenSize'
import { updateScreenType, setBrowserInitialized } from './reduxBit/actions'

const ScreenSizeWatcher = () => {
  const currentStateSize = useSelector((state) => state.device.screenType)
  const currentSize = useScreenSize()
  const dispatch = useDispatch()

  // Initially, the size may have come from the user agent or from the window.
  // Use whichever we have and update the redux state.
  useEffect(() => {
    if (currentSize !== currentStateSize) {
      dispatch(updateScreenType(currentSize))
    }
  }, [currentSize, currentStateSize, dispatch])

  useEffect(() => {
    dispatch(setBrowserInitialized(true))
  }, [dispatch])
  return null
}

export default ScreenSizeWatcher
